import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import Header from './../../Header';
import wpapi from 'wpapi';
import config from 'react-global-configuration';
import CryptoJS from 'crypto-js'
import $ from 'jquery';
import moment, { duration } from 'moment';
class Allreseller extends Component {
    constructor(props) {
        super(props);
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            reseller: [],
            partner_types: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            partnerUrl: this.decryptconfigdata('partnerUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            checkedDemoUser: localStorage.getItem('checkedDemoUser') ? localStorage.getItem('checkedDemoUser') : 0,
            activePage: 1,
            item_count: '',
            message: '',
            message12: '',
            res_search: '',
            status: localStorage.getItem('status') ? localStorage.getItem('status') : '',
            application_type: localStorage.getItem('application_type') ? localStorage.getItem('application_type') : '',
            partdetails: '',
            resel_customer: '',
            isLoadMore: 1,
            loading: 1,
            waiting: []
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.keywordChange = this.keywordChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.typeChange = this.typeChange.bind(this);
        this.resellertList = this.resellertList.bind(this);
        this._handleImport = this._handleImport.bind(this);
        this.importChange = this.importChange.bind(this);
        this.getSourceLink = this.getSourceLink.bind(this);

    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    importChange(e) {
        let csv = document.getElementById('uploadedFile').files.length;
        if (csv == 0) {
            this.setState({
                importResponse: 'No File selected'
            });
        } else {
            this.setState({ importResponse: undefined });
        }
    }
    getSourceLink(link) {
        if (link) {
            if (link.indexOf('http') !== -1) {
                var linknew = <a href={`${link}`}>{`${link}`}</a>;
                return linknew
            }
            else { return link }
        } else {
            let na = 'NA';
            return na;
        }
    }
    _handleImport(e) {

        let errors = {};

        e.preventDefault();

        let csv = document.getElementById('uploadedFile').files.length;

        const fd = new FormData;

        if (csv > 0) {

            if (window.confirm('Are you sure you want to import data from this file ?')) {

                for (var x = 0; x < csv; x++) {
                    fd.append("csv_files[]", document.getElementById('uploadedFile').files[x]);
                }

                this.setState({ importResponse: undefined });

                this.setState({ uploadMessage: 'Uploading the file' });

                fetch(this.state.apiUrl + '/PartnerRest/ImportPartners/userAuthKey/' + this.state.userAuthKey, {
                    method: 'POST',
                    dataType: 'json',
                    body: fd,
                })
                    .then((Response) => Response.json())
                    .then((findresponse) => {
                        findresponse = this.rawjsonparse(findresponse, 1);
                        if (findresponse.error == true) {
                            this.setState({
                                importResponse: findresponse.msg
                            });
                        } else {
                            this.setState({ importResponse: undefined });
                            alert('Data Successfully Imported');
                        }

                        this.setState({ uploadMessage: 'Upload' });
                        this.resellertList();
                    })
            } else {

                this.setState({
                    importResponse: 'You have cancelled the operation'
                });
            }
        } else {

            this.setState({
                importResponse: 'Please select a csv file'
            });
        }
    }

    removeMessage() {
        this.setState({ importResponse: '' })
    }
    approve(ele, resel) {
        if (window.confirm('Are you sure you want to approve this application ?')) {

            var joined = this.state.waiting.concat(resel.id);

            this.setState({ waiting: joined }, () => {

                if (resel.application_type_others == "Individual") {
                    var page_title = resel.name;
                } else {
                    var page_title = resel.company_name;
                }

                fetch(this.state.apiUrl + '/PartnerRest/Approve/id/' + resel.id + '/email/' + resel.email + '/userAuthKey/' + this.state.userAuthKey)
                    .then((Response) => Response.json())
                    .then((findresponse) => {
                        findresponse = ele.rawjsonparse(findresponse, 1);
                        if (ele.state.waiting.indexOf(resel.id) !== -1) {

                            var array = ele.state.waiting;

                            var index = array.indexOf(resel.id);

                            delete array[index];

                            ele.setState({ waiting: array })
                        }

                        alert(page_title + ' Partner is approved now');

                        if (findresponse.resel_customer == 1) {
                            // window.location.href='/tickets/'; 
                            this.setState({ message: 'Approved' })

                            this.resellertList();

                        } else {

                            this.setState({ message12: ' Not Approved' })
                        }

                    })
            })
        }
    }

    resendemail(ele, resel) {
        if (window.confirm('Are you sure you want to resend welcome email ?')) {

            var joined = this.state.waiting.concat(resel.id);

            this.setState({ waiting: joined }, () => {

                fetch(this.state.apiUrl + '/partnerRest/resendEmail/portal_id/' + resel.portaluser_id + '/email/' + resel.email + '/id/' + resel.id + '/userAuthKey/' + this.state.userAuthKey)
                    .then((Response) => Response.json())
                    .then((findresponse) => {
                        findresponse = ele.rawjsonparse(findresponse, 1);
                        this.setState({
                            responsedata: findresponse
                        })

                        if (ele.state.waiting.indexOf(resel.id) !== -1) {

                            var array = ele.state.waiting;

                            var index = array.indexOf(resel.id);

                            delete array[index];

                            ele.setState({ waiting: array })
                        }

                        if (this.state.responsedata == 1) {
                            //this.setState({message12:'Mail sent Successfully'}) 

                            alert('Mail sent Successfully to ' + resel.email);

                        } else {

                            this.setState({ message12: 'There might be a problem . Please contact our team.' })
                        }

                        this.resellertList();
                    })
            });
        }
    }

    deletePartner(ele, resel) {

        if (window.confirm('Are you sure you want to delete partner ?')) {

            var joined = this.state.waiting.concat(resel.id);

            this.setState({ waiting: joined }, () => {

                if (resel.post_id > 0) {

                    var site = new wpapi({
                        endpoint: this.decryptconfigdata('mainUrl') + '/wp-json',
                        username: this.decryptconfigdata('mainUrl_username'),
                        password: this.decryptconfigdata('mainUrl_password'),
                        auth: true,
                    });

                    site.deletePartner = site.registerRoute('wp/v2', '/delete_partner/(?P<id>\\d+)');
                    site.deletePartner()
                        .id(resel.post_id)
                        .then(function (res) {
                            console.log(res);
                        });
                }

                if (resel.application_type_others == "Individual") {
                    var page_title = resel.name;
                } else {
                    var page_title = resel.company_name;
                }

                fetch(ele.state.apiUrl + '/PartnerRest/DeletePartner/id/' + resel.id + '/userAuthKey/' + ele.state.userAuthKey)
                    .then((Response) => Response.json())
                    .then((findresponse) => {
                        findresponse = ele.rawjsonparse(findresponse, 1);

                        if (ele.state.waiting.indexOf(resel.id) !== -1) {

                            var array = ele.state.waiting;

                            var index = array.indexOf(resel.id);

                            delete array[index];

                            ele.setState({ waiting: array })
                        }

                        ele.resellertList();

                        alert(page_title + ' Partner is now deleted');
                    })

            });

        }
    }

    getPartnerStatus(status) {
        switch (status) {
            case '0':
                return 'Pending';
            case '1':
                return 'Active';
            case '2':
                return 'Inactive';
            case '3':
                return 'Pause';
            case '4':
                return 'Live';
            case '5':
                return 'Deleted';
            default:
                return 'Pending';
        }
    }

    //Creating Api for Wordpress to create post page
    goLivePartner(ele, resel) {
        if (window.confirm('Are you sure you want to make partner go live in the website ?')) {

            var joined = this.state.waiting.concat(resel.id);

            this.setState({ waiting: joined }, () => {

                var site = new wpapi({
                    endpoint: this.decryptconfigdata('mainUrl') + '/wp-json',
                    username: this.decryptconfigdata('mainUrl_username'),
                    password: this.decryptconfigdata('mainUrl_password'),
                    auth: true,
                });

                var obj = {};

                var sales_partner_type = [];

                var purposeArray = [];

                if (resel.partner_type_id == '3'
                    || resel.partner_type_id == '6'
                    || resel.partner_type_id == '5'
                    || resel.partner_type_id == '7') {

                    obj['min_project_budget'] = resel.min_project_budget;
                    obj['hourly_rate'] = resel.hourly_rate;
                    obj['portfolio'] = resel.portfolio;
                    obj['technologies'] = resel.skills;

                    if (resel.partner_type_id == '6') {
                        if (resel.purpose != null) {
                            purposeArray = resel.purpose.split(',');
                            obj['purpose'] = purposeArray;
                        }

                        obj['domain_specialization'] = resel.domain_specialization;
                    }
                }

                if (resel.application_type_others == "Individual") {
                    var page_title = resel.name;
                } else {
                    var page_title = resel.company_name;
                }

                obj['contact_person_name'] = resel.name;
                obj['contact_person_email'] = resel.email;
                obj['contact_person_phone'] = resel.phone;
                obj['website_address'] = resel.website;

                obj['partner_country'] = resel.country;
                obj['partner_state'] = resel.state;
                obj['partner_city'] = resel.city;
                obj['no._of_employees'] = resel.numberofcustomer;
                obj['show_on_partners_page'] = true;
                obj['partnership_type'] = resel.industry;

                //Written as per Wp :)
                obj['application_type'] = resel.application_type_others;

                if (!resel.company_logo) {
                    resel.company_logo = 'no-image.jpg';
                }

                site.partnerAPI = site.registerRoute('wp/v2', 'approved_partners');
                site.partnerAPI().create({
                    title: page_title,
                    content: resel.reason,
                    status: 'publish',
                    fields: obj
                }).then(function (post) {

                    site.partnerImage = site.registerRoute('wp/v2', '/partner_feature_image/(?P<id>\\d+)/(?P<logo>)');
                    site.partnerImage()
                        .id(post.id)
                        .logo(resel.company_logo)
                        .then(function (res) {

                            fetch(ele.state.apiUrl + '/PartnerRest/LivePartner/id/' + resel.id + '/post_id/' + post.id + '/slug/' + post.slug + '/userAuthKey/' + ele.state.userAuthKey)
                                .then((Response) => Response.json())
                                .then((findresponse) => {
                                    findresponse = ele.rawjsonparse(findresponse, 1);

                                    ele.resellertList();

                                    alert(page_title + ' Partner is now live');

                                    if (ele.state.waiting.indexOf(resel.id) !== -1) {

                                        var array = ele.state.waiting;

                                        var index = array.indexOf(resel.id);

                                        delete array[index];

                                        ele.setState({ waiting: array })
                                    }


                                })

                        });

                }).catch(function (err) {
                    //console.log('With Post' + err);

                    this.setState({ message12: err })

                    if (ele.state.waiting.indexOf(resel.id) !== -1) {

                        var array = ele.state.waiting;

                        var index = array.indexOf(resel.id);

                        delete array[index];

                        ele.setState({ waiting: array })
                    }

                });

            });
        }
    }

    goToPartner(ele, resel) {
        if (window.confirm('Are you sure to login this partner ?')) {
            var win = window.open(this.state.partnerUrl + "/login/resellerLogin/portalusr_email/" + resel.email + "/portaluser_id/" + resel.portaluser_id + "/reseller_login_superadmin/yes", '_blank');
            win.focus()
        }
    }

    export() {
        var win = window.open(this.state.apiUrl + "/PartnerRest/ExportPartners/userAuthKey/" + this.state.userAuthKey + "/status/" + this.state.status + "/application_type/" + this.state.application_type + "/res_search/" + this.state.res_search + "/demouser/" + this.state.demouser, '_blank');

        win.focus()
    }
    keywordChange(event) {
        var obj = this;
        this.setState({ res_search: event.target.value });
        //Delaying the function execute
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        this.timer = window.setTimeout(function () {
            //Execute the function code here...
            obj.resellertList();
        }, 500);
    }

    statusChange(event) {
        localStorage.setItem('status', event.target.value);
        this.setState({ status: event.target.value }, function () {
            this.resellertList();
        });
    }

    typeChange(event) {

        localStorage.setItem('application_type', event.target.value);

        this.setState({ application_type: event.target.value }, function () {
            this.resellertList();
        });

    }

    getTypechange(type) {
        if (type === '1') {
            return 'Referrer';
        }
        if (type === '2') {
            return 'Reseller';
        }
        return 'Referrer & Reseller';
    }

    details(id) {
        alert(id);
        fetch(this.state.apiUrl + '/PartnerRest/partnerdetails/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                this.setState({
                    partdetails: findresponse.partdetails
                })
            })
    }

    handlePageChange(pageNumber = 1) {
        var totalPages = Math.ceil(this.state.item_count / 20);
        if (this.state.activePage != pageNumber) {
            $(document).ready(function () {
                $('.pages').addClass('disabled');
            });
            this.setState({ activePage: pageNumber, setPage: 'no' });
            fetch(this.state.apiUrl + '/PartnerRest/AllReseller/page/' + pageNumber + '/userAuthKey/' + this.state.userAuthKey + '/userId/' + this.state.userId, {
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
                .then((Response) => Response.json())
                .then((findresponse) => {
                    findresponse = this.rawjsonparse(findresponse, 1);
                    $(document).ready(function () {
                        $('.pages').removeClass('disabled');
                        if (pageNumber == 1) {
                            $('.first_page').addClass('disabled');
                            $('.prev_page').addClass('disabled');
                        }
                        if (pageNumber == totalPages) {
                            $('.next_page').addClass('disabled');
                            $('.last_page').addClass('disabled');
                        }
                    });
                    this.setState({
                        reseller: findresponse.reseller,
                        offset: findresponse.offset,
                        off_count: findresponse.off_count,
                        setPage: 'yes'
                    })
                })
        }
    }

    resellertList(page = 1) {
        fetch(this.state.apiUrl + '/PartnerRest/AllReseller/page/' + page + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);

                this.setState({
                    loading: 0,
                    reseller: findresponse.reseller,
                    partner_types: findresponse.partner_types,
                    store_permission: findresponse.store_permission,
                    item_count: findresponse.item_count,
                    offset: findresponse.offset,
                    off_count: findresponse.off_count,
                    setPage: 'yes'
                })

            })
    }

    loadMorecount() {
        if (this.state.item_count > 0) {
            if (this.state.item_count >= 20) {
                if (this.state.isLoadMore != 2) {
                    if (this.state.isLoadMore == 1) {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="load_more" onClick={() => this.loadMore(this.state.activePage)}><span></span><span></span><span></span></div>
                            </div>
                        )
                    }
                    else {
                        return (
                            <div class="pagination-muvi" id="section07">
                                <div class="lds-ripple"><div></div><div></div></div>
                            </div>
                        )
                    }
                }
            }
        }
        else {
            return (
                <div className="text-center">No Data Found</div>
            )
        }
    }

    loadMore(pageNumber) {
        this.setState({ isLoadMore: 0 })
        pageNumber = pageNumber + 1;
        this.setState({ activePage: pageNumber });
        fetch(this.state.apiUrl + '/PartnerRest/AllReseller/page/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey + '/page/' + pageNumber, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.rawjsonparse(findresponse, 1);
                if (findresponse.reseller.length == 0) {
                    this.setState({
                        isLoadMore: 2
                    })
                } else {
                    this.setState({
                        isLoadMore: 1
                    })
                }
                this.setState({
                    //isLoadMore:1,
                    reseller: this.state.reseller.concat(findresponse.reseller),
                    //item_count: findresponse.item_count,
                })
            })
    }

    getResellerMenu(resel) {
        if (this.state.waiting.indexOf(resel.id) !== -1) {
            return (
                <div class="ajax-loader" id="waiting">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            )

        } else if (resel.status == 5) {

            return (
                <div tabindex="0" class="onclick-menu readonly">
                    <i class="far fa-ellipsis-v"></i>
                </div>
            )

        }
        else {

            if (resel.status > 0) {
                return (
                    <div tabindex="0" class="onclick-menu">
                        <i class="far fa-ellipsis-v"></i>
                        <ul class="onclick-menu-content text-left">
                            <li onClick={() => this.resendemail(this, resel)}><a>Resend Email</a></li>
                            <li onClick={() => this.goToPartner(this, resel)}><a>Login to Partner Account </a></li>
                            {resel.is_live == 0 ? <li onClick={() => this.goLivePartner(this, resel)}><a>Go Live</a></li> : ''}
                            <li onClick={() => this.deletePartner(this, resel)}><a>Delete</a></li>
                        </ul>
                    </div>

                )
            }
            else {
                return (
                    <div tabindex="0" class="onclick-menu">
                        <i class="far fa-ellipsis-v"></i>
                        <ul class="onclick-menu-content text-left">
                            <li onClick={() => this.approve(this, resel)}><a>Approve</a></li>
                            <li onClick={() => this.deletePartner(this, resel)}><a>Delete</a></li>
                        </ul>
                    </div>
                )
            }
        }
    }

    getResellerDetails() {

        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        }
        else {
            return (

                <div class="list_check">
                    <div class="tickets hidden-xs">
                        <ul class="tickets_head adv">
                            <li class="intra_col_15">Date Of Signup</li>
                            <li class="intra_col_20">Name</li>
                            <li class="intra_col_15">Company</li>
                            <li class="intra_col_15">Email</li>
                            <li class="intra_col_10">Type</li>
                            <li class="intra_col_10">Source</li>
                            <li class="intra_col_10">Status</li>
                            <li class="intra_col_5">Action</li>
                        </ul>
                        {
                            this.state.reseller.map((resel, key) =>
                                <ul class={resel.status == '5' ? 'tickets_number disabled_partners' : 'tickets_number'} >
                                    <li class="intra_col_15">{resel.add_date ? moment(resel.add_date).format('DD-MMM-YYYY') : '--'}</li>
                                    <li class="intra_col_20 text-inded">{<Link key={key} to={`/resellerCustomer/${resel.id}`} name={"max"}>{resel.name}</Link>}</li>
                                    <li class="intra_col_15 text-inded">{resel.company_name ? resel.company_name : '--'}</li>

                                    <li class="intra_col_15 text-inded">{resel.email}</li>
                                    <li class="intra_col_10">{resel.industry}</li>
                                    <li class="intra_col_10">{this.getSourceLink(resel.source)}</li>
                                    <li class="intra_col_10">
                                        {resel.is_live == 1 ? 'Live' : this.getPartnerStatus(resel.status)}
                                    </li>
                                    <li class="intra_col_5 text-center">
                                        {this.getResellerMenu(resel)}
                                    </li>
                                </ul>
                            )
                        }
                    </div>
                    <div class="custmer_mob hidden-md">
                        {
                            this.state.reseller.map((resel, key) =>
                                <div class={resel.status == '5' ? 'custmer_list_mob disabled_partners' : 'custmer_list_mob'} >
                                    <Link key={key} to={`/resellerCustomer/${resel.id}`} name={"max"}>
                                        <h4 class="list_title text-inded">{resel.name}</h4>
                                    </Link>
                                    <Link key={key} to={`/resellerCustomer/${resel.id}`} name={"max"}>
                                        <div class="wrap text-inded">{resel.email}</div>
                                    </Link>
                                    {this.getResellerMenu(resel)}
                                </div>
                            )
                        }
                    </div>
                    {this.state.item_count > 0 ? <div class="pagination-muvi">
                        <Pagination
                            itemClass={'pages'}
                            itemClassFirst={'first_page'}
                            itemClassPrev={'prev_page'}
                            itemClassNext={'next_page'}
                            itemClassLast={'last_page'}
                            activePage={this.state.activePage}
                            itemsCountPerPage={20}
                            totalItemsCount={this.state.item_count}
                            pageRangeDisplayed={5}
                            onChange={this.state.setPage == 'yes' ? this.handlePageChange : ''}
                        />
                        <div style={{ color: "#333" }}>
                            {(this.state.offset + 1) + ' - ' + (this.state.offset + this.state.off_count)} of {this.state.item_count}
                        </div>
                    </div> : <div className="text-center" style={{ color: "#333" }}>No Data Found</div>}
                    {/* {this.loadMorecount()} */}
                </div>
            )
        }
    }

    /*
    * Author : P ANIL KUMAR REDDY
    * Er : 63630
    * Email : anil@muvi.com
    * Function is for check and uncheck filter data to show in dashboard
    */
    checkedDemouser(event) {
        let isChecked = event.target.checked;
        if (event.target.checked == true) {
            localStorage.setItem('checkedDemoUser', 1);
            this.setState({ demouser: event.target.checked }, function () {
                this.resellertList();
            });
        } else {
            localStorage.setItem('checkedDemoUser', 0);
            this.setState({ demouser: event.target.checked }, function () {
                this.resellertList();
            });
        }
    }

    componentDidMount() {
        document.title = "Intranet | Allreseller";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        if (localStorage.getItem('checkedDemoUser') == 1) {
            console.log(1);
            this.state.demouser = true;
            console.log(this.state.demouser);
        } else {
            this.state.demouser = false;
            console.log(0);
            console.log(this.state.demouser);
        }
        this.resellertList();
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="partners" brecum_page="All Partners" />
                <div class="modal fade" id="myModal" role="dialog">
                    <div class="modal-dialog modal-md">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="close" data-dismiss="modal">&times;</button>
                                <h4 class="modal-title">Import Partners</h4>
                            </div>
                            <div class="modal-body">
                                <p class="red">{this.state.importResponse ? this.state.importResponse : ''}</p>

                                <form onSubmit={this._handleImport} method="POST">
                                    <div class="form-group">
                                        <div class="input-group">
                                            <input type="hidden" id="filename" name="filename" value="" />
                                            <input type="file" id="uploadedFile" name="uploadedFile" class="form-control form-control-sm" accept=".csv" onChange={this.importChange} />
                                            <div class="input-group-btn">
                                                <button type="submit" class="rounded-0 btn btn-primary">{this.state.uploadMessage ? this.state.uploadMessage : 'Upload'}</button>



                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <Link to={this.state.apiUrl + '/uploads/csv/partners-import-template.csv'} name={"max"} target="_blank" > <button className="btn btn-blue mob-btn" >Sample Download</button></Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_col">
                    <div className="red">{this.state.message12}</div>
                    <section class="customer">
                        <div id="exTab1" class="container">
                            <ul class="nav nav-pills">
                                <li class="active">
                                    <Link to={`/allreseller/`} name={"max"} class="tab">All</Link>
                                </li>
                                <li>
                                    <Link to={`/reseller/`} name={"max"} class="tab">Reseller</Link>
                                </li>
                                <li>
                                    <Link to={`/managereferer/`} name={"max"} class="tab">Referrer</Link>
                                </li>
                                <li>
                                    <Link to={`/affiliates/`} name={"max"} class="tab">Affiliates</Link>
                                </li>
                            </ul>
                            <div class="tab-content clearfix">
                                <div class="tab-pane active" id="Leads">
                                </div>
                            </div>
                        </div>
                        <div class="top-row margin_less">
                            <div class="left-section btn-muvi pull-left hidden-sm">
                                <a class="btn btn-sky" href="javascript:void(1);" onClick={() => this.removeMessage()} data-toggle="modal" data-target="#myModal"><span>Import Csv</span> <span class="mob_icon_plus"></span> </a>
                                <button id="export" class="btn btn-blue" onClick={() => this.export()} >Excel Export</button>
                            </div>
                            <div class="right-section">
                                <div className="row">
                                    <div className="col-md-5 col-xs-12">
                                        <div class="searchTicket emp_dept wid_100">
                                            <input type="text" class="form-control" id="searchkeyword" name="searchkeyword" placeholder="Search Company,Name and Email" onChange={this.keywordChange} />
                                            <button type="submit"><i class="fa fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-xs-6">
                                        <div className="filter">
                                            <select class="form-control" onChange={this.typeChange} value={this.state.application_type}>
                                                <option value='0'>Types</option>
                                                {this.state.partner_types.map((dynamicData, key) =>

                                                    <option value={dynamicData.partner_type_id}>{dynamicData.partner_type_name}</option>

                                                )}
                                            </select>
                                            <i class="fal fa-angle-down"></i>
                                        </div>
                                    </div>
                                    <div className="col-md-3 col-xs-6">
                                        <div className="filter">
                                            <select class="form-control" onChange={this.statusChange} value={this.state.status}>
                                                <option value="">Status</option>
                                                <option value="0">Pending</option>
                                                <option value="1">Active</option>
                                                <option value="2" >Inactive</option>
                                                <option value="3" >Pause</option>
                                                <option value="4" >Live</option>
                                                <option value="5" >Deleted</option>
                                            </select>
                                            <i class="fal fa-angle-down"></i>
                                        </div>
                                    </div>
                                    <div className="col-md-1 col-xs-6 onclick-menu demouser-div" tabindex="0">
                                        <i class="far fa-ellipsis-v"></i>
                                        <ul class="onclick-menu-content text-left demouser-popup">
                                            <input type="checkbox" defaultChecked={this.state.checkedDemoUser == 1 ? 'checked' : ''} onChange={event => this.checkedDemouser(event)} />
                                            <label class="demouser-checkbox">Show Demo User</label>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="clearfix"></div>
                        {this.getResellerDetails()}
                    </section>
                </div>
            </div>
        )
    }
}
export default Allreseller


// WEBPACK FOOTER //
// ./src/components/partner/allreseller.js